module.exports = __webpack_public_path__ + "img/intro-screen03.ff8dc3ec.png";